export type SceneRevealSource = {
  getProgress: () => number;
};

export type SceneRevealStages = {
  water: number;
  lighting: number;
  caustics: number;
  decor: number;
  particles: number;
  gameplay: number;
};

const SCENE_REVEAL_DURATION = 2.8;

const clamp01 = (value: number) => Math.min(1, Math.max(0, value));

const smoothStepRange = (start: number, end: number, value: number) => {
  const progress = clamp01((value - start) / (end - start));
  return progress * progress * (3 - 2 * progress);
};

export class SceneRevealController {
  private startedAt: number | null = null;
  private progress = 1;

  reset(progress = 0) {
    this.startedAt = null;
    this.progress = clamp01(progress);
  }

  start(time: number) {
    this.startedAt = time;
    this.progress = 0;
  }

  update(time: number) {
    if (this.startedAt === null) {
      this.start(time);
    }

    const startedAt = this.startedAt ?? time;
    this.progress = clamp01((time - startedAt) / SCENE_REVEAL_DURATION);
    return this.progress >= 1;
  }

  getProgress() {
    return this.progress;
  }
}

export function getSceneRevealStages(progress: number): SceneRevealStages {
  const value = clamp01(progress);

  return {
    water: smoothStepRange(0.0, 0.34, value),
    lighting: smoothStepRange(0.08, 0.48, value),
    caustics: smoothStepRange(0.2, 0.68, value),
    decor: smoothStepRange(0.38, 0.86, value),
    particles: smoothStepRange(0.18, 0.74, value),
    gameplay: smoothStepRange(0.72, 1.0, value),
  };
}
